import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ProductType } from '../Enums/productType';
import { ApiService } from './Common/api.service';

@Injectable({
  providedIn: 'root'
})
export class IsjustAddedService {
  isJustAdded: boolean = false;
  
  constructor() {
    
}



}
